import { render, staticRenderFns } from "./CrudTable.vue?vue&type=template&id=52eb123a"
import script from "./CrudTable.vue?vue&type=script&lang=js"
export * from "./CrudTable.vue?vue&type=script&lang=js"
import style0 from "./CrudTable.vue?vue&type=style&index=0&id=52eb123a&prod&lang=css"
import style1 from "./CrudTable.vue?vue&type=style&index=1&id=52eb123a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports